<template>
  <div id="cards">
    <div style="margin-left: 11%;">
      <dv-decoration-11 style="width:250px;height:60px;">
        SKU数量:
        <span style="color: yellow;font-weight: bold;font-size: 18px;">{{ num2 }}</span>
        个
      </dv-decoration-11>
    </div>

    <div style="margin-left: 53%;">
      <dv-decoration-11 style="width:250px;height:60px;">
        接入渠道数量:
        <span style="color: yellow;font-weight: bold;font-size: 18px;">{{ num1 }}</span>
        家
      </dv-decoration-11>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data () {
    return {
      num1: '',
      num2: '',

    }
  },
  mounted() {
    setInterval(this.getData1, 60000);
    // 接入渠道数量
    this.getData1();
    setInterval(this.getData2, 60000);
    // SKU数量
    this.getData2();
  },
  methods: {
    // 接入渠道数量
    getData1() {
      axios.post(this.$api+"channel/getChannelNum").then((result) => {
        this.num1=result.data;
      });
    },
    // SKU数量
    getData2() {
     
      axios.post(this.$api+"product/getProductNum").then((result) => {

        this.num2 = result.data;
      });
    }
  }
}
</script>

<style lang="less">
#cards {
  display: flex;
  width: 99%;
  justify-content: space-flex-start;
  height: 5%;
  margin-top: -70px;

  .card-item {
   margin-right: auto;
  }

}
</style>
